import { newRelic } from '../App';

// Logging code apart from the NewRelic configuration
// In Case we want to change the logging system, we can do it here.

export const logErrorToMonitorSystem = (error: string, customAttributes?: Record<string, any>): void => {
  try {
    newRelic.noticeError(error, customAttributes);
  } catch (err) {
    // Handle any errors that may occur during logging
    console.error('Error logging to New Relic:', err);
  }
};
